import { BRANCH_STATUS_MAP, INDIAN_CURRENCY_CODE, DOCUMENT_TITLE_TYPE, LoginTypes } from "../data/constants";
import store from "../redux/store";
import { clearLocalStorage, getLocalStorage } from "../utils";
import { APP_SOURCE, APP_SOURCE_TYPES, LOCALSTORAGE_KEYS } from "../data/local-storage-constants";
import _, { cloneDeep, isEmpty } from "lodash";
import { ACCOUNTING_TABS_MAP } from "../data/accounting-constants";
import { haveReconEngineAccess } from "./accounting-helper";
import { SubTabsDataType } from "../layouts/header";
import GitInfo from "./generatedGitInfo.json";
import { fetchCardDetailsData, resetCardDetails } from "../redux/slices/ristaCard";


export const currency = () => {
  let currency: string = store.getState().businessReducer?.businessData?.currencyCode;
  let windowObj: any = window;
  let currencyUnicode = windowObj.RL?.common?.curr[currency];
  if (currencyUnicode) {
    return decodeHtmlEntity(currencyUnicode);
  }
  return currency || decodeHtmlEntity(windowObj.RL?.common?.curr[INDIAN_CURRENCY_CODE]);
};

export const refreshRistaCards = (dispatch: any, setPageIndex: (pageIndex: number) => void, pageSize = 10) => {
  dispatch(resetCardDetails());
  setPageIndex(0);
  dispatch(fetchCardDetailsData({ dataToPost: { pageSize } }));
};

export const currencyCode = () => {
  let currency: string = store.getState().businessReducer?.businessData?.currencyCode;
  return currency || INDIAN_CURRENCY_CODE;
};
export const setDocumentTitle = (titleText: string) => {
  document.title = titleText;
  return () => {
    document.title = DOCUMENT_TITLE_TYPE.default;
  };
};

/**
 * This function will return the list of active branches
 * @param {*} allowedBusinessBranchesDataMap
 */
export const getActiveBranches = (allowedBusinessBranchesDataMap: any) => {
  return Object.keys(allowedBusinessBranchesDataMap).reduce((preState: any, curKey: string) => {
    let curState = cloneDeep(preState);
    if (allowedBusinessBranchesDataMap[curKey].status === BRANCH_STATUS_MAP.ACTIVE) {
      curState[curKey] = allowedBusinessBranchesDataMap[curKey];
    }
    return curState;
  }, {})

};

/**
 * This function will return the true if given feature is allowed for current user
 * @param {*} feature
 */
export const isFeatureAllowed = (feature: string) => {
  let allowedFeatures =
    store.getState().businessReducer?.userData?.allowedFeatures || [];
  return allowedFeatures?.length && allowedFeatures.includes(feature);
};

/**
 * This function will filter out the options with are not allowed for the user
 * @param {*} tooltipOptionsMap
 */
export const getFilteredTooltipOptions = (tooltipOptionsMap: Record<string, SubTabsDataType>): Record<string, SubTabsDataType> => {
  const { userData, businessData, licences = [] } = store.getState().businessReducer;
  let filteredMap: any =
    Object.values(tooltipOptionsMap)?.reduce((prevVal, tabItem) => {
      let featureTypes = tabItem?.feature;
      let { isShow = true } = tabItem;

      if (tabItem.visibilityCheck && !tabItem.visibilityCheck(userData)) {
        return prevVal; // skip this tab
      }
      
      //check for user email
      if (isShow && tabItem.emailIds && !isEmpty(tabItem.emailIds)) {
        isShow = tabItem.emailIds.findIndex(userEmail => userEmail === userData?.contactInfo?.email) !== -1;
      }
      //check for licence
      const licences_list = licences.map((licence: { licenceCode: string }) => licence.licenceCode);
      if (isShow && tabItem.licences && !isEmpty(tabItem.licences)) {
        isShow = tabItem.licences.findIndex(licence => licences_list.includes(licence)) !== -1;
      }
      //check for businessName
      if (isShow && tabItem.businessNames && !isEmpty(tabItem.businessNames)) {
        isShow = tabItem.businessNames.findIndex(businessName => businessName === businessData?.businessName) !== -1;
      }
      let checkMultipleFeature = false;

      if (Array.isArray(featureTypes)) {
        featureTypes.forEach((element: any) => {
          if (isFeatureAllowed(element)) {
            checkMultipleFeature = true;
          }
        });
      }
      // TODO: ONLINE_RECON - This check is just for testing and needs to changed in future.
      if (
        !haveReconEngineAccess() &&
        tabItem.tabId === ACCOUNTING_TABS_MAP.online_order_reconciliation.tabId
      ) {
        isShow = false;
      }
      if (
        tabItem.permission &&
        tabItem.permission?.length &&
        !tabItem?.permission.includes(userData?.role)
      ) {
        isShow = false;
      }
      if (
        (!tabItem?.feature ||
          isFeatureAllowed(Array.isArray(tabItem?.feature) ? '' : tabItem?.feature) ||
          checkMultipleFeature) &&
        isShow
      ) {
        prevVal[tabItem.tabId] = tabItem;
      }
      return prevVal;
    }, {} as Record<string, SubTabsDataType>) || {};
  return filteredMap;
};

export const isSourcePos = () =>
  getLocalStorage(APP_SOURCE) === APP_SOURCE_TYPES.POS;

export const closeTab = () => {
  window.opener = null;
  window.open("", "_self");
  window.close();
};

// Function to remove multiple key-value pairs
export const removeKeys = (object: any, keys: any) => {
  const newObj = { ...object };
  keys.forEach((key: any) => {
    delete newObj[key];
  });
  return newObj;
};
/*
  returns form data with all object key values
*/
export const createFormData = (data: any) => {
  let formData: any = new FormData();
  Object.entries(data).forEach((val: any, index: any) => {
    formData.append(val[0], val[1]);
  });
  return formData;
};

/**
 * Checks whether the passed value is string
 * @param inputVal input value
 * @returns true or false based on whether given value is a string or not
 */
export const isString = (inputVal: any) => {
  return typeof inputVal === "string";
};

/**
 * Checks whether the passed value is a object
 * @param inputVal input value
 * @returns true or false based on whether given value is a object or not
 */
export const isObject = (inputVal: any) => {
  return inputVal === Object(inputVal);
};

export function getCurrentPlatform() {
  const userAgent = navigator?.userAgent;

  if (/Mac/i.test(userAgent)) return 'osx';
  if (/Win/i.test(userAgent)) return 'windows';
  if (/Android/i.test(userAgent)) return 'android';
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios';

  return 'web';
}

export function getLoginMetaInfo({ loginType }: {loginType?: LoginTypes} = {}) {
  const versionInfo = getCurrentReleaseVersion();

  const metaInfo: Record<string, any> = {
    userAgent: navigator.userAgent,
    rmpVersion: versionInfo.rmpVersion,
    type: getCurrentPlatform(),
  };
  if (loginType) {
    metaInfo.loginType = loginType;
  }
  return metaInfo;
}

/**
 * Checks whether the passed string is empty
 * @param inputStr input string
 * @returns true or false based on whether given string is empty
 */
export const isStringEmpty = (inputStr: string) => {
  if (!inputStr || (isString(inputStr) && inputStr.trim().length < 1)) {
    return true;
  }
  return false;
};

/**
 * Checks whether the passed object is empty
 * @param inputVal input value
 * @returns true or false based on whether given object is empty
 */
export const isObjectEmpty = (inputVal: any) => {
  for (let prop in inputVal) {
    if (inputVal.hasOwnProperty(prop)) return false;
  }
  return true;
};

/**
 * removes keys with null, undefined, empty, etc values
 * @param inputVal input value
 */
const removeFalsyValuesUtil = (inputVal: any) => {
  for (let i in inputVal) {
    if (isObject(inputVal[i])) {
      removeFalsyValuesUtil(inputVal[i]);
    }
    if (
      inputVal[i] === null ||
      inputVal[i] === undefined ||
      (inputVal[i].trim && isStringEmpty(inputVal[i])) ||
      (isObject(inputVal[i]) && isObjectEmpty(inputVal[i]))
    ) {
      delete inputVal[i];
    }
  }
  return inputVal;
};

/**
 * removes keys with null, undefined, empty, etc values
 * @param inputVal input value
 */
export const removeFalsyValues = (inputVal: any) => {
  let returnVal = removeFalsyValuesUtil(cloneDeep(inputVal));
  return returnVal;
};

/**
 * round number upto two decimal point
 * @param inputVal input value
 */
export const round2 = (inputVal: any) => {
  if (isNaN(inputVal)) {
    return "-";
  }
  return Math.round((inputVal + Number.EPSILON) * 100) / 100;
};

/**
 * send color code via random number
 * @param inputVal input value
 */
export const generateRandomColorCode = (input: number) => {
  switch (input % 10) {
    case 1:
      return "#2A77F2";
    case 2:
      return "#575757";
    case 3:
      return "#4E875B";
    case 4:
      return "#6283AC";
    case 5:
      return "#E7B73D";
    case 6:
      return "#0088FE";
    case 7:
      return "#00C49F";
    case 9:
      return "#FFBB28";
    default:
      return "#FF8042";
  }
};

export const isSupportLogin = () => {
  const isSupportLogin = getLocalStorage(LOCALSTORAGE_KEYS.IS_SUPPORT_LOGIN);
  return isSupportLogin ? JSON.parse(isSupportLogin) : false;
};

export const clearSupportLoginData = () => {
  clearLocalStorage();
}
export const checkSupportLogout = () => {
  if (isSupportLogin()) {
    clearSupportLoginData();
  }
};
//Function to change custom dates in date range selector
export function getOptionForDates(customDisabledDates: any) {
  return [
    {
      value: "Last 7 days",
      totalDays: 7,
    },
    {
      value: "Last 15 days",
      totalDays: 15,
    },
    {
      value: "Last 30 days",
      totalDays: 30,
    },
    {
      value: "Last 60 days",
      totalDays: 60,
    },
    {
      value: "Last 90 days",
      totalDays: 90,
    },
    {
      value: "Since inception",
      totalDays: customDisabledDates,
    },
  ];
}

export function getLowercaseKey(value: string): string {
  return value.toLowerCase().trim().replace(" ", "_");
}

/**
 * converts string array to map of objects
 * @param inputArray input array of string
 */
export const convertStrArrToMapOfObj = (
  inputArray: string[]
): Record<string, { key: string; label: string }> => {
  let result: Record<string, { key: string; label: string }> = {};
  for (let label of inputArray) {
    if (!_.isString(label) || !label.trim()) continue;
    let key = getLowercaseKey(label);
    result[key] = {
      key,
      label,
    };
  }
  return result;
};


/**
 * This function will convert array to object using key
 * @param {*} inputArr
 */
export function convertArrayToObject<T>(
  inputArr: T[],
  uniqueKey: keyof T & string,
  convertLowerCase = true,
): Record<string, T> {
  const lowerCase = (key: string) => {
    if (!convertLowerCase) return key;
    return key && key.toLocaleLowerCase();
  }
  return inputArr.reduce((acc, cur) => {
    return { ...acc, [lowerCase(cur[uniqueKey] as unknown as string)]: cur };
  }, {} as Record<string, T>);
}

/**
 * Generates a random float between two numbers.
 * @param upperLimit - The upper limit of the range.
 * @param lowerLimit - The lower limit of the range.
 * @returns A random float between lowerLimit and upperLimit.
 */
export function generateRandom(upperLimit: number, lowerLimit = 0): number {
  return Math.random() * (upperLimit - lowerLimit) + lowerLimit;
}

/**
 * Filters branches based on labels with AND logic between categories and OR logic within categories
 * Algorithm:
 * 1. Group selected labels by their categories
 * 2. If labels from multiple categories are selected → AND logic: branch must have at least one label from EACH category
 * 3. If multiple labels from same category are selected → OR logic: branch can have any of those labels
 * 
 * Example:
 * - Category1: COCO
 * - Category2: North, South
 * - Branch must have: COCO AND (North OR South)
 * 
 * @param branches - Array of branch objects
 * @param branchLabels - Array of selected label strings
 * @param branchLabelsCategoryMap - Optional map of label to category: { label: category }
 * @returns branches that match the label criteria
 */
export function filterBranchUsingLabel(
  branches: Record<string, any>[],
  branchLabels: string[],
  branchLabelsCategoryMap?: Record<string, string>
) {
  if (!branchLabels?.length) return [];
  
  // If category map is provided and has entries, apply AND/OR logic
  if (branchLabelsCategoryMap && Object.keys(branchLabelsCategoryMap).length > 0) {
    // Step 1: Group selected labels by category
    const labelsByCategory: Record<string, string[]> = {};
    branchLabels.forEach((label) => {
      const category = branchLabelsCategoryMap[label] || "Uncategorized";
      if (!labelsByCategory[category]) {
        labelsByCategory[category] = [];
      }
      labelsByCategory[category].push(label);
    });

    const categories = Object.keys(labelsByCategory);
    if (categories.length === 0) return [];

    // Step 2: Filter branches - AND logic between categories, OR logic within categories
    return branches.filter((branch) => {
      const branchLabelsList = branch.branchLabels || [];
      
      // AND logic: branch must have at least one label from EACH selected category
      return categories.every((category) => {
        const categoryLabels = labelsByCategory[category];
        // OR logic within category: branch needs at least one label from this category
        return categoryLabels.some((label) => branchLabelsList.includes(label));
      });
    });
  }
  
  // Fallback to simple OR logic if no category map provided
  return branches.filter(branch => branch.branchLabels.some((label: string) => branchLabels.includes(label)));
}

/**
 * Filters inventory branches based on labels with AND logic between categories and OR logic within categories
 * Same algorithm as filterBranchUsingLabel but for inventory branches
 * 
 * @param branches - Array of inventory branch objects
 * @param inventoryBranchLabels - Array of selected label strings
 * @param inventoryBranchLabelsCategoryMap - Optional map of label to category: { label: category }
 * @returns branches that match the label criteria
 */
export function filterInventoryBranchUsingLabel(
  branches: Record<string, any>[],
  inventoryBranchLabels: string[],
  inventoryBranchLabelsCategoryMap?: Record<string, string>
) {
  if (!inventoryBranchLabels?.length) return [];
  
  // If category map is provided and has entries, apply AND/OR logic
  if (inventoryBranchLabelsCategoryMap && Object.keys(inventoryBranchLabelsCategoryMap).length > 0) {
    // Step 1: Group selected labels by category
    const labelsByCategory: Record<string, string[]> = {};
    inventoryBranchLabels.forEach((label) => {
      const category = inventoryBranchLabelsCategoryMap[label] || "Uncategorized";
      if (!labelsByCategory[category]) {
        labelsByCategory[category] = [];
      }
      labelsByCategory[category].push(label);
    });

    const categories = Object.keys(labelsByCategory);
    if (categories.length === 0) return [];

    // Step 2: Filter branches - AND logic between categories, OR logic within categories
    return branches.filter((branch) => {
      const branchLabelsList = branch.inventoryBranchLabels || [];
      
      // AND logic: branch must have at least one label from EACH selected category
      return categories.every((category) => {
        const categoryLabels = labelsByCategory[category];
        // OR logic within category: branch needs at least one label from this category
        return categoryLabels.some((label) => branchLabelsList.includes(label));
      });
    });
  }
  
  // Fallback to simple OR logic if no category map provided
  return branches.filter(branch => branch.inventoryBranchLabels?.some((label: string) => inventoryBranchLabels.includes(label)));
}

// Sends a message from the child iframe to the parent window with a given event key
export const sendEventRequest = (key: string, payload: any = {}) => {
  window.parent.postMessage(
    {
      detail: {
        key,
        ...payload,
      },
    },
    "*"
  );
};
const decoder = document.createElement("textarea");
const decodeHtmlEntity = (html: string) => {
  if (!html) return "";
  decoder.innerHTML = html;
  return decoder.value;
};

export function getCurrentReleaseVersion() {
  const rmpVersionInfo = GitInfo.rmpGitInfo || "";
  return {
    rmpVersion: rmpVersionInfo,
  };
}

export function getCurrentVersionText() {
  const versions = getCurrentReleaseVersion();
  let versionText = `${versions.rmpVersion}`;
  return versionText;
}